import { render, staticRenderFns } from "./Bem.vue?vue&type=template&id=140cff75&"
import script from "./Bem.vue?vue&type=script&lang=js&"
export * from "./Bem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports